var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95.9579,
    height: 95.9579,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2286 74.9721C20.8415 74.9721 19.7899 74.6365 19.0739 73.9653C18.358 73.2493 18 72.332 18 71.2133C18 70.0051 18.3356 68.8864 19.0068 67.8572C19.7228 66.7833 20.6401 65.9331 21.7588 65.3066C22.8775 64.6802 24.0409 64.367 25.2491 64.367C25.786 64.367 26.323 64.4341 26.86 64.5683C27.4417 64.6578 28.001 64.8144 28.538 65.0382V32.4173H31.0215V65.2395C31.0215 67.1637 30.5964 68.8641 29.7462 70.3407C28.9407 71.7726 27.8668 72.9137 26.5244 73.7639C25.2267 74.5693 23.7948 74.9721 22.2286 74.9721Z",
    fill: "#04FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1462 56.5547C45.7591 56.5547 44.7075 56.2191 43.9915 55.5479C43.2756 54.832 42.9176 53.9147 42.9176 52.796C42.9176 51.5878 43.2532 50.4691 43.9244 49.4399C44.6404 48.366 45.5577 47.5158 46.6764 46.8893C47.7951 46.2629 48.9585 45.9496 50.1667 45.9496C50.7036 45.9496 51.2406 46.0167 51.7776 46.151C52.3593 46.2405 52.9186 46.3971 53.4556 46.6208V14H55.9391V46.8222C55.9391 48.7463 55.514 50.4467 54.6638 51.9234C53.8583 53.3553 52.7844 54.4964 51.442 55.3466C50.1443 56.152 48.7124 56.5547 47.1462 56.5547Z",
    fill: "#04FFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2071 74.5465C67.82 74.5465 66.7684 74.2109 66.0525 73.5397C65.3365 72.8238 64.9785 71.9064 64.9785 70.7878C64.9785 69.5796 65.3141 68.4609 65.9853 67.4317C66.7013 66.3578 67.6186 65.5076 68.7373 64.8811C69.856 64.2546 71.0194 63.9414 72.2276 63.9414C72.7646 63.9414 73.3015 64.0085 73.8385 64.1428C74.4202 64.2323 74.9796 64.3889 75.5165 64.6126V31.9918H78V64.814C78 66.7381 77.5749 68.4385 76.7247 69.9152C75.9192 71.3471 74.8453 72.4882 73.5029 73.3384C72.2052 74.1438 70.7733 74.5465 69.2071 74.5465Z",
    fill: "#04FFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.6096d26e9c367c29e6008b8b77e6dd9f.svg";
export { ForwardRef as ReactComponent };